export const pendingCaseHandler = (variableName: string, defaultValue?: any) => (state: any, action: any) => {
  const requestIdVariableName = `${variableName}RequestId`;
  state[requestIdVariableName] = action.meta.requestId;
  if (defaultValue) {
    state[variableName] = defaultValue;
  }
};

export const rejectedCaseHandler = (variableName: string, defaultValue?: any) => (state: any, action: any) => {
  if (action.error?.name !== 'CanceledError') {
    console.error(`${variableName} operation failed:`, action.error?.message ?? 'Unknown error');
  }
  const requestIdVariableName = `${variableName}RequestId`;
  const errorVariableName = `${variableName}Error`;
  if (state[requestIdVariableName] === action.meta.requestId) {
    state[requestIdVariableName] = null;
    action.meta?.arg?.onReject?.();
    //TODO: refactor (campaign management)
    if (Object.hasOwn(state, errorVariableName)) {
      state[errorVariableName] = action.payload;
    }
    if (defaultValue) {
      state[variableName] = defaultValue;
    }
  }
};

export const fulfilledCaseHandler = (variableName: string) => (state: any, action: any) => {
  const dataVariableName = variableName;
  const requestIdVariableName = `${dataVariableName}RequestId`;
  const errorVariableName = `${dataVariableName}Error`;
  if (state[requestIdVariableName] === action.meta.requestId) {
    state[requestIdVariableName] = null;
    if (Object.hasOwn(state, dataVariableName)) {
      state[dataVariableName] = action.payload;
    }
    if (Object.hasOwn(state, errorVariableName)) {
      state[errorVariableName] = null;
    }
  }
};
